<div class="labor-rates-container" [formGroup]="laborRatesForm">
    <fieldset>
        <legend>
            {{'PROPERTIES_LABOR_RATES_SALES_OFFICE' | translate}}
        </legend>
        <div class="row">
            <label class="row-margin horizontal-padding">
                {{'PROPERTIES_LABOR_RATES_LABOR_RATE_ESTIMATE' | translate}}
            </label>
            <label class="row-margin  horizontal-padding">
                {{'PROPERTIES_LABOR_RATES_LABOR_RATE_ESTIMATE_PBO' | translate}}
            </label>
        </div>

        <div class="row col-sm-10 align-items-center">
            <div class="row col-sm-3 align-items-center">
                <label class=" horizontal-padding">
                    {{'PROPERTIES_LABOR_RATES_BUSINESS_LINE' | translate}}
                </label>
            </div>

            <div class="col-sm-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select formControlName="businessLine">
                        @for (line of businessLines; track trackById($index, line)) {
                            <mat-option [value]="line.id">
                                {{ line.description }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row col-sm-10 align-items-center">
            <div class="row col-sm-3 align-items-center">
                <label class=" horizontal-padding">
                    {{'PROPERTIES_LABOR_RATES_SALES_OFFICE' | translate}}
                </label>
            </div>

            <div class="col-sm-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select formControlName="salesOffice">
                        @for (office of salesOffices; track trackById($index, office)) {
                            <mat-option [value]="office.id">
                                {{ office.description }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row col-sm-10 align-items-center">
            <div class="row col-sm-3 align-items-center">
                <label class=" horizontal-padding">
                    {{'PROPERTIES_LABOR_RATES_SEGMENT' | translate}}
                </label>
            </div>

            <div class="col-sm-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select formControlName="segment">
                        @for (segment of segments; track trackById($index, segment)) {
                            <mat-option [value]="segment.id">
                                {{ segment.description }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row col-sm-10 align-items-center">
            <div class="row col-sm-3 align-items-center">
                <label class=" horizontal-padding">
                    {{'PROPERTIES_LABOR_RATES_BUSINESS_HIERARCHY' | translate}}
                </label>
            </div>

            <div class="col-sm-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select formControlName="businessHierarchy">
                        @for (bh of businessHierarchies; track bh.subSegmentId) {
                            <mat-option [value]="bh.subSegmentId">
                                {{ bh.subSegment }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row col-sm-10 align-items-center">
            <div class="row col-sm-3 align-items-center">
                <label class=" horizontal-padding">
                    {{'PROPERTIES_LABOR_RATES_GCK_CODE' | translate}}
                </label>
            </div>

            <div class="col-sm-4">
                {{gckValue}}
            </div>
        </div>

        @if (showOfferingControls) {
            <div class="row col-sm-10 align-items-center">
                <div class="row col-sm-3 align-items-center">
                    <label class="horizontal-padding">
                        {{'PROPERTIES_LABOR_RATES_OFFERING' | translate}}
                    </label>
                </div>

                <div class="col-sm-4">
                    <mat-radio-group formControlName="offering" class="offering-radio-group">
                        <mat-radio-button [value]="true">
                            {{'PROPERTIES_LABOR_RATES_FIRE_ALARM' | translate}}
                        </mat-radio-button>
                        <mat-radio-button [value]="false">
                            {{'PROPERTIES_LABOR_RATES_FIRE_SPRINKLER' | translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        }

        <div class="row row-margin labor-rates-table-wrapper">
            <div class="scrollable-table-overflow">
                <table mat-table [dataSource]="laborRates" class="mat-elevation labor-rates-table">

                    <ng-container matColumnDef="labor">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'PROPERTIES_LABOR_RATES_LABOR' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.labor}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pm">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            {{'PM' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            {{element.pm | multilingualCurrency}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="eng">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            {{'ENG' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            {{element.eng | multilingualCurrency}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="eeng">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            {{'EENG' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            {{element.eeng | multilingualCurrency}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="leng">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            {{'LENG' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            {{element.leng | multilingualCurrency}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="spec">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            {{'SPEC' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            {{element.spec | multilingualCurrency}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="mech">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            {{'MECH' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            @if(element.labor === "PBO"){
                                <mat-checkbox color="primary" 
                                                [checked]="mechRateProvidedByOther" 
                                                class="table-checkbox" 
                                                [disabled]="true">
                                </mat-checkbox>
                            }
                            @else{
                                {{element.mech | multilingualCurrency}}
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="elec">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            {{'ELEC' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            @if (element.labor === "PBO"){
                                <mat-checkbox color="primary"
                                                [checked]="elecRateProvidedByOther" 
                                                class="table-checkbox"
                                                [disabled]="true">
                                </mat-checkbox>
                            }
                            @else{
                                {{element.elec | multilingualCurrency}}
                            }
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="row-height labor-rates-table-header"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-height"></tr>
                </table>

                @if (showUsePLCheckbox) {
                    <div class="labor-rates-use-PL">
                        <mat-checkbox color="primary"
                                        [checked]="usePL"
                                        class="use-PL-checkbox"
                                        [disabled]="true">
                        </mat-checkbox>
                        <label class="use-PL-label">
                            {{'PROPERTIES_LABOR_RATES_USE_PL' | translate}}
                        </label>
                    </div>
                }
            </div>
        </div>
    </fieldset>

    <fieldset>
        <legend>
            {{'PROPERTIES_LABOR_RATES_SERVICING_OFFICE' | translate}}
        </legend>

        <div class="row col-sm-10 align-items-center">
            <div class="row col-sm-3 align-items-center">
                <label class="horizontal-padding">
                    {{'PROPERTIES_LABOR_RATES_ENG_OFFICE' | translate}}
                </label>
            </div>
            <div class="col-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select formControlName="engOffice">
                        @for (office of engOffices; track office.salesofficeId) {
                            <mat-option [value]="office.salesofficeId">
                                {{ office.salesOfficeName }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row labor-rates-table-wrapper">
            <div class="warning-message-container">
                <div class="scrollable-table-overflow">
                    <table mat-table [dataSource]="engOfficeRates" class="mat-elevation labor-rates-table">

                            <ng-container matColumnDef="labor">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{'PROPERTIES_LABOR_RATES_LABOR' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.labor}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="pm">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'PM' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.pm | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="eng">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'ENG' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.eng | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="ceng">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'CENG' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.ceng | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="leng">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'LENG' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.leng | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="neng">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'NENG' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.neng | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="qeng">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'QENG' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.qeng | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="grap">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'GRAP' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.grap | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="prog">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'PROG' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.prog | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="spec">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'SPEC' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.spec | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="dds">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'DDS' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.dds | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="mech">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'MECH' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.mech | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="elec">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    {{'ELEC' | translate}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    {{element.elec | multilingualCurrency}}
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedEngOfficeColumns" class="row-height labor-rates-table-header"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedEngOfficeColumns;" class="row-height"></tr>
                    </table>
                    @if (showEngOfficeWarning) {
                        <div class="labor-rates-error-container">
                            <mat-icon class="labor-rates-warning-icon">warning</mat-icon>
                        </div>
                    }
                </div>
                @if (showEngOfficeWarning) {
                    <span class="error-message">
                        <label>
                            {{'PROPERTIES_LABOR_RATES_ENG_OFFICE_WARNING' | translate}}
                        </label>
                        <label>
                            {{'PROPERTIES_LABOR_RATES_ENG_OFFICE_WARNING_EXAMPLE' | translate}}
                        </label>
                    </span>
                }
            </div>
        </div>
        <div class="row col-sm-10 row-margin">
            <div class="row col-sm-3 align-items-center">
                <label class="horizontal-padding">{{'PROPERTIES_LABOR_RATES_DEPLOYMENT' |
                    translate}}</label>
            </div>
            <div class="col-sm-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select formControlName="deployment">
                        @for (office of deploymentOffices; track office.salesofficeId) {
                            <mat-option [value]="office.salesofficeId">
                                {{ office.salesOfficeName }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row labor-rates-table-wrapper">
            <div class="warning-message-container">
                <div class="scrollable-table-overflow">
                    <table mat-table [dataSource]="deploymentOfficeRates" class="mat-elevation labor-rates-table">
        
                        <ng-container matColumnDef="labor">
                            <th mat-header-cell *matHeaderCellDef>
                                {{'PROPERTIES_LABOR_RATES_LABOR' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.labor}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="pm">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'PM' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.pm | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="eng">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'ENG' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.eng | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="ceng">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'CENG' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.ceng | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="leng">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'LENG' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.leng | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="neng">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'NENG' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.neng | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="qeng">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'QENG' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.qeng | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="grap">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'GRAP' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.grap | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="prog">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'PROG' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.prog | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="spec">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'SPEC' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.spec | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="dds">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'DDS' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.dds | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="mech">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'MECH' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.mech | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="elec">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                {{'ELEC' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-end">
                                {{element.elec | multilingualCurrency}}
                            </td>
                        </ng-container>
        
                        <tr mat-header-row *matHeaderRowDef="displayedDeploymentOfficeColumns"
                            class="row-height labor-rates-table-header"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedDeploymentOfficeColumns;" class="row-height"></tr>
                    </table>
        
                    @if (showDeploymentWarning) {
                        <div class="labor-rates-error-container">
                            <mat-icon class="labor-rates-warning-icon">warning</mat-icon>
                        </div>
                    }
                </div>
                @if (showDeploymentWarning) {
                    <span class="error-message">
                        <label>
                            {{'PROPERTIES_LABOR_RATES_ENG_OFFICE_WARNING' | translate}}
                        </label>
                        <label>
                            {{'PROPERTIES_LABOR_RATES_DDEP_OFFICE_WARNING_EXAMPLE' | translate}}
                        </label>
                    </span>
                }
            </div>
        </div>
        <div class="row col-sm-3 applied-offices-btn row-margin">
            <button mat-raised-button color="primary" (click)="appliedOffices()" [disabled]="isReadOnly">
                {{'PROPERTIES_LABOR_RATES_APPLIED_OFFICES' | translate}}
            </button>
        </div>
    </fieldset>
</div>